(function (window, document) {

  /*
   * Initialer Seitenaufruf
   */
  PIANO.Utils.trigger('pushstate');

})();
